import "@features/summary/css/summaryPage.scss";
import { Box } from "@mui/material";
import { FlyingCart } from "@features/cart/components/FlyingCart";
import { InstallationPreOrder } from "@features/installation/InstallationPreOrder";
import { InstallationNoInstall } from "@features/installation/InstallationNoInstall";
import { InstallationDateChange } from "@features/installation/InstallationDateChange";
import { InstallationEquipment } from "@features/installation/InstallationEquipment";
import { InstallationAppointment } from "@features/installation/InstallationAppointment";
import { FlowCard } from "@common/FlowCard/FlowCard";
import { useTranslation } from "react-i18next";
import { useInstallationPage } from "./useInstallationPage";
import type { IInstallationPageParams } from "./useInstallationPage";

export const InstallationPage = (props: IInstallationPageParams) => {
    const { flyingCart, nextStep } = props;
    const { t } = useTranslation("installation");
    const {
        appointmentInitialValues,
        appointmentType,
        classes,
        error,
        filteredActivationDateList,
        firstAvailableDate,
        getActivationDates,
        handleNextClick,
        installationInfoContent,
        installationInfoTitle,
        isLoading,
        isMobile,
        noInstallFormMethods,
        offerId,
        prequal,
        setAppointmentFormValues,
        showBookInstallationAppointment,
        showInstallationInfoFlowCard,
    } = useInstallationPage(props);

    return (
        <div className={classes.containerBoxed}>
            <Box display="flex" gap={4}>
                <Box
                    display="flex"
                    flexDirection="column"
                    gap={3}
                    height="fit-content"
                    maxWidth={isMobile ? "100%" : 700}
                    width="100%"
                >
                    {showBookInstallationAppointment && offerId && (
                        <FlowCard title={t("bookInstallationAppointment")}>
                            <InstallationAppointment
                                initialValues={appointmentInitialValues}
                                offerId={offerId}
                                onFormValuesChange={setAppointmentFormValues}
                            />
                        </FlowCard>
                    )}
                    {showInstallationInfoFlowCard && (
                        <FlowCard title={installationInfoTitle}>
                            {installationInfoContent.kind === "preorder" && (
                                <InstallationPreOrder serviceDate={installationInfoContent.serviceDate} />
                            )}
                            {installationInfoContent.kind === "no-install" && (
                                <InstallationNoInstall
                                    error={error}
                                    filteredActivationDateList={filteredActivationDateList}
                                    firstAvailableDate={firstAvailableDate}
                                    formMethods={noInstallFormMethods}
                                    isLoading={isLoading}
                                    onRetryFetch={getActivationDates}
                                />
                            )}
                        </FlowCard>
                    )}
                    <FlowCard title={t("yourEquipment")}>
                        <InstallationEquipment appointmentType={appointmentType} isPreOrder={prequal?.isPreOrder} />
                    </FlowCard>
                    {!prequal?.isPreOrder && (
                        <FlowCard title={t("dateChange")}>
                            <InstallationDateChange appointmentType={appointmentType} />
                        </FlowCard>
                    )}
                </Box>
                <FlyingCart flyingCart={flyingCart} nextStep={nextStep} onNextClick={handleNextClick} />
            </Box>
        </div>
    );
};
